import Cookies from 'js-cookie';
import setScrollBarWidth from 'set-scrollbar-width';
import './localize';
import './algolia-search';
import nativeLazy from './native-lazy';
import Grid from './grid.js';
import htmxEvents from './htmx';
import eventDates from './event-dates';
import accordion from './accordion';
import memberAccountCreation from './member-account-creation';
import memberProfile from './member-profile';
import memberRegistration from './member-registration';
import sizeCoverHeroImages from './cover-hero-images';

import feather from 'feather-icons';
var elementsToReplace = document.querySelectorAll('[data-feather]');

Array.from(elementsToReplace).forEach(function (element) {
  let icon = element.getAttribute('data-feather');
  if (typeof feather.icons[icon] === 'undefined') {
    element.removeAttribute('data-feather');
  }
});
feather.replace();
window.Cookies = Cookies;

import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import persist from '@alpinejs/persist';
import Clipboard from '@ryangjchandler/alpine-clipboard';
import '@justinribeiro/lite-youtube';
import '@slightlyoff/lite-vimeo';
import trixEvents from "./trix"

Alpine.plugin(collapse);
Alpine.plugin(persist);
Alpine.plugin(Clipboard);
Alpine.data('accordion', accordion);
Alpine.data('memberAccountCreation', memberAccountCreation);
Alpine.data('memberProfile', memberProfile);
Alpine.data('memberRegistration', memberRegistration);
window.Alpine = Alpine;
Alpine.start();
sizeCoverHeroImages();
setScrollBarWidth();
nativeLazy();

// Filter Checkbox Counts
let filterCheckboxes = document.querySelectorAll('.filter-checkbox');
filterCheckboxes.forEach(element => {
  element.addEventListener('click', function(event) {
    let wrapper = element.closest('.filter-wrapper'); // The parent that wraps the whole thing
    let dropdownButton = wrapper.querySelector('.filter-button'); // The button that wraps the indicator
    let indicator = dropdownButton.querySelector('.filter-count'); // The indicator itself
    let optionsWrapper = element.closest('.filter-options'); // The wrapper for all the options
    let checkedOptions = optionsWrapper.querySelectorAll('.filter-checkbox:checked'); // All the checked ones

    // Hide the indicator if there are no checked options
    if (checkedOptions.length === 0) {
      indicator.classList.add('invisible');
    } else {
      // Otherwise, make sure it's visible and update it
      indicator.classList.remove('invisible');
      indicator.innerHTML = checkedOptions.length;
    }
  });
});

function setButtonBackToOriginal() {
  let submitButtons = document.querySelectorAll("button[type='submit'].fui-submit");
  submitButtons.forEach(button => {
    button.disabled = false;
    button.innerText = button._originalLabel || 'Submit';
  });
}

function generateCheckoutAttemptId() {
  if (window.crypto && typeof window.crypto.randomUUID === 'function') {
    return window.crypto.randomUUID();
  }

  if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
    const bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);
    return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
  }

  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

function attachCheckoutAttemptIds() {
  const checkoutForms = document.querySelectorAll('form[action="/actions/video-consortium-module/stripe/create-checkout-session"]');

  checkoutForms.forEach((form) => {
    form.addEventListener('submit', () => {
      let input = form.querySelector('input[name="checkoutAttemptId"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'checkoutAttemptId';
        form.appendChild(input);
      }

      if (!input.value) {
        input.value = generateCheckoutAttemptId();
      }
    });
  });
}

function persistFormValuesAsDefaults(form) {
  form.querySelectorAll('input, textarea, select').forEach((field) => {
    if (!field.name || field.type === 'file') {
      return;
    }

    if (field.type === 'checkbox' || field.type === 'radio') {
      field.defaultChecked = field.checked;
      return;
    }

    if (field.tagName === 'SELECT') {
      Array.from(field.options).forEach((option) => {
        option.defaultSelected = option.selected;
      });
      return;
    }

    field.defaultValue = field.value;
  });
}

document.addEventListener("DOMContentLoaded", function () {
  attachCheckoutAttemptIds();

  let $form = document.querySelector('[data-fui-form]');

  if ($form) {
    // Disable Formie's automatic scroll to error
    if ($form.form && $form.form.formTheme && $form.form.formTheme.settings) {
      $form.form.formTheme.settings.scrollToTop = false;
    }

    // Store original button labels so we can restore them after submit
    $form.querySelectorAll("button[type='submit'].fui-submit").forEach(button => {
      button._originalLabel = button.innerText;
    });

    $form.addEventListener('onBeforeFormieSubmit', (e) => {
      $form.classList.add('fui-submitting');

      let submitButtons = $form.querySelectorAll("button[type='submit'].fui-submit");
      submitButtons.forEach(button => {
        button.disabled = true;
        button.innerText = "Loading...";
      });
    });

    $form.addEventListener('onFormieValidate', (e) => {
      // Small delay to get it asynchronously
      setTimeout(() => {
        if (e.detail.invalid === true) {
          $form.classList.remove('fui-submitting');
          setButtonBackToOriginal()

          // Scroll to error alert instead of first invalid field
          const errorAlert = document.querySelector('.fui-alert-error');
          if (errorAlert) {
            errorAlert.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
      }, 100);
    });

    $form.addEventListener('onAfterFormieValidate', (e) => {
      console.log('onAfterFormieValidate', e.detail);
    });

    $form.addEventListener('onAfterFormieSubmit', (e) => {
      if ($form.querySelector('input[name="handle"]')?.value === 'vcMemberEdit') {
        persistFormValuesAsDefaults($form);
      }

      $form.classList.remove('fui-submitting');
      setButtonBackToOriginal();
    });

    $form.addEventListener('onFormieSubmitError', (e) => {
      $form.classList.remove('fui-submitting');
      setButtonBackToOriginal();
    });
  } // if $form

  // Dismiss Formie alerts on click (delegated on document since alerts render outside the form)
  document.addEventListener('click', (e) => {
    const alert = e.target.closest('.fui-alert');
    if (alert) {
      alert.classList.add('fui-alert--dismissing');
      alert.addEventListener('transitionend', () => alert.remove(), { once: true });
    }
  });

  const galleryGrid = new Grid({
    balanceColumns: true,
    rootSelector: '.js-gallery-grid',
    renderSelector: '.js-gallery-grid-display',
    columns: 5,
    gap: '1.5rem',
    breakpoints: [
      { width: 992, columns: 4, gap: '1rem' },
      { width: 768, columns: 3, gap: '1rem' },
      { width: 480, columns: 2, gap: '1rem' }
    ],
    onReady: function(grid) {
      if (window.Alpine) {
        Alpine.initTree(grid.renderContainer);
      }
      nativeLazy();
    },
    onResizeStop: function(grid) {
      if (window.Alpine) {
        Alpine.initTree(grid.renderContainer);
      }
      nativeLazy();
    },
  });

  htmxEvents.init();
  eventDates.init();
  trixEvents.init();
}); // DOMContentLoaded
